import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

import { LicenceService } from "@services/licence.service";
import { UiService } from "@services/ui.service";
import { Licence } from '@classes/licence/licence';


@Injectable()
export class LicencesResolver implements Resolve<Licence[]> {
    constructor(
        private licenceSrv: LicenceService,
        private uiSrv: UiService
    ) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Licence[]> {
        this.uiSrv.routeLoadingStateChanged.next(true);

        return this.licenceSrv.getList()
        .pipe(
            tap(() => {
                this.uiSrv.routeLoadingStateChanged.next(false);
            })
        );
    }
}
